import React from "react"
import { Route } from "react-router-dom"
import { connect } from "react-redux"
import { StripeProvider } from "react-stripe-elements"
import Account from "./Account"
import Payment from "./Payment"
import Submit from "./Submit"
import FAQ from "./FAQ"
import { addBeforeUnload, unmountBeforeUnload } from "../../common/common"
import { STRIPE_API_KEY } from "../../common/constants"
import TimedOut from "./TimedOut"

// Breadcrumbs should be put here
class PaymentFlow extends React.Component {
  componentDidMount() {
    addBeforeUnload()
    window.scrollTo(0, 0)
  }

  componentWillUnmount() {
    unmountBeforeUnload()
  }

  render() {
    return this.props.timedOut ? (
        <TimedOut />
    ) : (
      <StripeProvider apiKey={STRIPE_API_KEY}>
        <React.Fragment>
          <Route path="/pay/account" component={Account} />
          <Route path="/pay/payment" component={Payment} />
          <Route path="/pay/submit" component={Submit} />
          <Route path="/pay/faq" component={FAQ} />
        </React.Fragment>
      </StripeProvider>
    )
  }
}

const mapStateToProps = (state) => ({
  timedOut: state.payment.timedOut
})

export default connect(mapStateToProps)(PaymentFlow)



// WEBPACK FOOTER //
// ./assets/payment/components/index.js